export interface AnalyticsDateRange {
    from: Date;
    to: Date;
    compareFrom: Date;
    compareTo: Date;
}

export const DEFAULT_DATE_RANGE: AnalyticsDateRange = {
    from: new Date(),
    to: new Date(),
    compareFrom: new Date(),
    compareTo: new Date(),
};
